import { AUTH_HINT_KEY } from '../config/auth.config.js'

function setAuthHint() {
  localStorage.setItem(AUTH_HINT_KEY, '1')
}

function removeAuthHint() {
  localStorage.removeItem(AUTH_HINT_KEY)
}

function hasAuthHint() {
  return Boolean(localStorage.getItem(AUTH_HINT_KEY))
}

class AuthUtility {
  /**
   * Persist a local hint that the user has signed in before. Boot logic
   * uses this to decide whether to attempt session restore. The hint is
   * not the session itself — auth remains in the HTTP-only cookie.
   *
   * @returns {void}
   */
  set() {
    return setAuthHint()
  }

  /**
   * Clear the signed-in-before hint from localStorage.
   *
   * @returns {void}
   */
  remove() {
    return removeAuthHint()
  }

  /**
   * Whether the signed-in-before hint is present in localStorage.
   *
   * @returns {boolean}
   */
  has() {
    return hasAuthHint()
  }
}

export default new AuthUtility()
